export const getZppCertifiedSubscriptionPlan =
  ({ course }) =>
  (state) => {
    return state.payment.subscriptionPlans.find(({ zppCertified, zppCourseGroupSlug }) => !!zppCertified && zppCourseGroupSlug === course);
  };
